import React from 'react';
import Col from 'react-bootstrap/Col';
import EditView from './EditView';
import InteractionEditor from '../interaction/InteractionEditor';
import InteractionList from '../interaction/InteractionList';
import JobList from '../job/JobList';
import MiscSaleEditor from '../misc-sale/MiscSaleEditor';
import MiscSaleList from '../misc-sale/MiscSaleList';
import ProposalEditor from '../proposal/ProposalEditor';
import ProposalList from '../proposal/ProposalList';
import ProposalSelector from '../job/ProposalSelector';
import SalesAppointmentEditor from '../sales-appointment/SalesAppointmentEditor';
import SalesAppointmentList from '../sales-appointment/SalesAppointmentList';
import ServiceCallEditor from '../service-call/ServiceCallEditor';
import ServiceCallList from '../service-call/ServiceCallList';

const CustomerRelatedRecordsView = (props) => {
    return (
        <Col>
            <EditView
                customerId={props.customerId}
                divId={'appointments'}
                getUrl={`/api/calendar/appointments/sales?customerId=${props.customerId}`}
                title={'APPOINTMENTS'}>
                <SalesAppointmentList />
                <SalesAppointmentEditor />
            </EditView>
            <EditView
                customerId={props.customerId}
                divId={'proposals'}
                getUrl={`/api/proposals/list?customerId=${props.customerId}`}
                title={'PROPOSALS'}>
                <ProposalList />
                <ProposalEditor />
            </EditView>
            <EditView
                customerId={props.customerId}
                divId={'jobs'}
                getUrl={`/api/jobs/list?customerId=${props.customerId}`}
                title={'JOBS'}>
                <JobList />
                <ProposalSelector />
            </EditView>
            <EditView
                customerId={props.customerId}
                divId={'miscsales'}
                getUrl={`/api/miscsales/list?customerId=${props.customerId}`}
                title={'MISC SALES'}>
                <MiscSaleList />
                <MiscSaleEditor />
            </EditView>
            <EditView
                customerId={props.customerId}
                divId={'servicecalls'}
                getUrl={`/api/servicecalls/list?customerId=${props.customerId}`}
                title={'SERVICE CALLS'}>
                <ServiceCallList />
                <ServiceCallEditor />
            </EditView>
            <div style={{ minHeight: '100vh' }}>
                <EditView
                    customerId={props.customerId}
                    divId={'interactions'}
                    getUrl={`/api/interactions/list?customerId=${props.customerId}`}
                    title={'INTERACTION LOGS'}>
                    <InteractionList />
                    <InteractionEditor />
                </EditView>
            </div>
        </Col>
    );
}

export default CustomerRelatedRecordsView;